import { SxProps, Theme } from "@mui/material/styles";

const styles: Record<string, SxProps<Theme>> = {
  wrapper: {
    width: "100%",
    minHeight: "500px",
    position: "relative",
  },
  addForm: {
    position: "fixed",
    width: "calc(100% - 250px)",
    bottom: "24px",
  },
  dataWrapper: {
    display: "flex",
    flexDirection: "column",
  },
  tokenBox: {
    border: "1px solid #E0E4EE",
    borderRadius: "8px",
    p: "12px",
    wordWrap: "break-word"
  },
  buttons: {
    display: "flex",
    flexDirection: "row",
    gap: "12px",
    width: "100%",
    marginTop: "24px",

    "button": {
      width: "100%",
    }
  }
};

export default styles;
